import angular from 'angular';
import {auth} from './auth/auth.js';
import {common} from './common/common.js';
import {dashboard} from './dashboard/dashboard.js';
import {dijagnoza} from './dijagnoza/dijagnoza.js';
import {tip} from './tip/tip.js';
import {djelatnik} from './djelatnik/djelatnik.js';
import {grad} from './grad/grad.js';
import {pacijent} from './pacijent/pacijent.js';
import {pregled} from './pregled/pregled.js';
import {nalaz} from './nalaz/nalaz.js';
import {uputnica} from './uputnica/uputnica.js';
import {pristanak} from './pristanak/pristanak.js';

const components = angular.module('components', [
    auth.name,
    common.name,
    dashboard.name,
    dijagnoza.name,
    tip.name,
    djelatnik.name,
    grad.name,
    pacijent.name,
    pregled.name,
    nalaz.name,
    uputnica.name,
    pristanak.name
]);


export {components};



// WEBPACK FOOTER //
// ./app/components/components.js